export const ROLES = [
  {
    id: 1,
    label: "Cadre (cadre de santé)",
  },
  {
    id: 2,
    label: "Médecin (chirurgien)",
  },
  {
    id: 3,
    label: "Paramédical (infirmier / aide-soignant)",
  },
  {
    id: 4,
    label: "Administratif (secrétaire)",
  },
  {
    id: 5,
    label: "Social (assistante sociale)",
  },
];